// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__33eHh","info":"Note_info__2GWwR","note":"Note_note__3KZox","actions":"Note_actions__1T68K"};